import { ReactNode } from 'react'
import { Container, Description, Header, Sticker, Title } from './style'

type Props = {
    children?: ReactNode
    className?: string
    description?: string
    stickerUrl?: string
    title: string
}

const Alert = ({ children, className, description, stickerUrl, title }: Props) => (
    <Container className={className}>
        {stickerUrl && <Sticker src={stickerUrl} alt="" />}
        <Header>
            <Title>{title}</Title>
            {description && <Description>{description}</Description>}
        </Header>
        {children}
    </Container>
)

export default Alert
